import apiRequest from "../../utils/apiRequest";

export const updateSingleRoleApi = async (roleId, selectedPermissions) => {
    const updatedData = {
        permission: selectedPermissions,
    };
    return await apiRequest(`update_permissions/${roleId}`, "post", updatedData);
};

export const updateSingleRoleAdminApi = async (roleId, selectedPermissions) => {
    const updatedData = {
        permission: selectedPermissions,
    };
    return await apiRequest(`admin/role/${roleId}`, "put", updatedData);
}
